import styled from 'styled-components'

const WarpBarLineChart = styled.div`
  width: 15rem;
  > div {
    padding-bottom: 12px;
    > :nth-child(1) {
      display: flex;
      font-weight: bold;
      justify-content: space-between;
    }
    > :nth-child(2) {
      background-color: #f0f0f0;
      border-radius: 0.3rem;
      display: flex;
      height: 1rem;
    }
  }
`

const WarpSimpleLine = styled.div<{ color?: string; width: number }>`
  background-color: ${props => props.color || '#f0f0f0'};
  border-radius: 0.3rem;
  height: 1rem;
  width: ${props => `${props.width}%`};
`

export { WarpBarLineChart, WarpSimpleLine }
